import React from 'react';

const ErrorPage = () => {
  return (
    <div className="content">
      <h1>An Error Has Occurred!</h1>
    </div>
  );
};

export default ErrorPage;
